module.exports = __webpack_public_path__ + "static/media/softline.40db287f.png";